import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");
    try {
      const response = await fetch("https://agepcoatings.com/forgotpasswordcourse", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Failed to send reset email");

      setMsg(data.message || "Password reset email sent! Please check your inbox.");

      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={{
      display: "flex",
      maxWidth: "900px",
      margin: "50px auto",
      borderRadius: "50px",
      overflow: "hidden",
      boxShadow: "0 0 15px rgba(0,0,0,0.2)"
    }}>
      {/* Left side image */}
      <div style={{
        flex: 1,
        backgroundImage: "url('https://static.vecteezy.com/system/resources/previews/022/213/251/non_2x/businessman-checking-the-steps-through-document-with-a-list-of-checkboxes-regulation-concepts-of-practices-and-policies-procedure-company-articles-of-association-terms-and-conditions-free-photo.jpg')", // replace with your image path or import it
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderTopLeftRadius: "50px",
        borderBottomLeftRadius: "50px",
        minHeight: "400px",
      }}></div>

      {/* Right side form */}
      <div style={{
        flex: 1,
        background: "#fff",
        padding: "40px 30px",
        borderTopRightRadius: "50px",
        borderBottomRightRadius: "50px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}>
        <h3 style={{ marginBottom: "30px", textAlign: "center", fontWeight: "bold" }}>Forgot Password</h3>
        <form onSubmit={handleReset}>
          <div className="mb-3">
            <label>Email address</label>
            <input
              type="email"
              className="form-control"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
            />
          </div>
          <button type="submit" className="btn btn-outline-dark rounded-5 w-100">
            Send Reset Email
          </button>
        </form>

        {msg && <div className="alert alert-success mt-3 text-center">{msg}</div>}
        {error && <div className="alert alert-danger mt-3 text-center">{error}</div>}
      </div>
    </div>
  );
}
